import { DriverQueryParams, DriversPageViews, QueryParamDataType, WorkspaceSettingsViews } from '../constants';

const DriversPageQueryParams = {
  [DriverQueryParams.VIEW]: {
    required: false,
    type: QueryParamDataType.STRING,
    acceptedValues: DriversPageViews,
  },
  [DriverQueryParams.SETTINGS]: {
    required: false,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: WorkspaceSettingsViews,
  },
  [DriverQueryParams.DRIVER]: {
    required: false,
    type: QueryParamDataType.STRING,
  },
};

export default DriversPageQueryParams;
